const CDN_BASE_URL = 'https://cdn.lingdongzhen.com' // 确保所有资源都通过 HTTPS 加载。即使你的主页面是 HTTPS，如果页面内嵌了 http:// 的图片、脚本、API（即“混合内容”），浏览器仍可能标记为不安全。

export const defAvatarUrl = `${CDN_BASE_URL}/source/background.jpg` // 'http://cdn.lingdongzhen.com/background.jpg' // '/videos/backgroumd.jpg'
export const QINIU_BASE_URL = CDN_BASE_URL // 'http://sv0ehlx40.hn-bkt.clouddn.com'
// 在开发阶段，如果你希望 TranSorURL 指向本地视频文件，推荐的做法如下：
// 将视频文件放在 public 目录下
// 例如：f:\aigc\public\videos\demo.mp4
// 使用相对路径访问
// 你可以这样设置 TranSorURL：n
// filepath:f:\aigc\src\api\constants.jsexport//const//TranSorURL='/videos/demo.mp4'
// 访问方式说明n
// 这样配置后，开发服务器（如 Vite、Webpack Dev Server）会自动将 public 目录下的内容作为静态资源提供。你可以通过 http://localhost:端口/videos/demo.mp4 访问到该视频。
// 注意：
// 不要把视频放在 src 目录下，src 里的文件不会被当作静态资源直接访问。
// 生产环境请使用 CDN 或云存储链接。
export const TranSorURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4` // '/videos/TranSorVideo.mp4'
export const TranResURL = `${CDN_BASE_URL}/source/TranResVideo.mp4` // '/videos/TranResVideo.mp4'

export const videoRepearSorURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4`
export const videoRepearResURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4`

export const videoSuperSorURL = `${CDN_BASE_URL}/source/videoSuperSor.mp4`
export const videoSuperResURL = `${CDN_BASE_URL}/source/videoSuperRes.mp4`

export const videoMatSorURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4`
export const videoMatResURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4`

export const videoSrtSorURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4`
export const videoSrtResURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4`

// 图片资源
export const imgMatSorURL = `${CDN_BASE_URL}/source/imgMatSor.jpg`
export const imgMatResURL = `${CDN_BASE_URL}/source/imgMatRes.png`
export const imgSuperSorURL = `${CDN_BASE_URL}/source/imgSuperSor.png`
export const imgSuperResURL = `${CDN_BASE_URL}/source/imgSuperRes.png`
export const imgUpperSorURL = `${CDN_BASE_URL}/source/imgUpperSor.jpg`
export const imgUpperResURL = `${CDN_BASE_URL}/source/imgUpperRes.png`

// 音频资源
export const voiceDenoiseSorURL = `${CDN_BASE_URL}/source/voiceDenoiseSor.wav`
export const voiceDenoiseResURL = `${CDN_BASE_URL}/source/voiceDenoiseRes.wav`
export const voiceSrtSorURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4`
export const voiceSrtResURL = `${CDN_BASE_URL}/source/TranSorVideo.mp4`

// 其他资源
export const videoDownURL = `${CDN_BASE_URL}/source/videoDown.png`

// 【新增】音频原语音克隆翻译 —— 翻译的目标语言选项（value 为发送给后端的语言代码）
export const audioCloneTranslateLanguages = [
  { value: 'zh', label: '中文 (Chinese)' },
  { value: 'en', label: '英语 (English)' },
  { value: 'ja', label: '日语 (Japanese)' },
  { value: 'es', label: '西班牙语 (Spanish)' },
  { value: 'ar', label: '阿拉伯语 (Arabic)' }
]

// 【新增】分步视频翻译（精细视频翻译）—— 第一步生成字幕时可选的翻译目标语言
export const stepwiseVideoTranslateLanguages = [
  { value: 'zh', label: '中文' },
  { value: 'en', label: '英语' },
  { value: 'ja', label: '日语' },
  { value: 'es', label: '西班牙语' },
  { value: 'ar', label: '阿拉伯语' }
]
